(() => {
  if (window.__bfNativeAudioBridgeInitialized) return;
  window.__bfNativeAudioBridgeInitialized = true;

  const isNativeAudio = (audio) =>
    audio instanceof HTMLAudioElement && !audio.__bfPlayerHooked;

  document.addEventListener(
    'play',
    (event) => {
      const audio = event.target;
      if (!isNativeAudio(audio)) return;

      const previous = window.__bfCurrentAudio;
      if (previous && previous !== audio) previous.pause();

      audio.__bfNativeProductAudio = true;
      window.__bfCurrentAudio = audio;
      window.dispatchEvent(new CustomEvent('bf:audio-play', { detail: audio }));
    },
    true
  );

  document.addEventListener(
    'ended',
    (event) => {
      const audio = event.target;
      if (!isNativeAudio(audio)) return;
      if (window.__bfCurrentAudio === audio) window.__bfCurrentAudio = null;
    },
    true
  );
})();
